import { registerEditor } from './registry.js'

import NumericEditor from './NumericEditor.tsx'
import StringEditor from './StringEditor.tsx'
import MarkdownEditor from './MarkdownEditor.tsx'
import TimelineEditor from './TimelineEditor.tsx'
import PhotoEditor from './PhotoEditor.tsx'
import SingleSelectEditor from './SingleSelectEditor.tsx'
import MultiSelectEditor from './MultiSelectEditor.tsx'

export const registerAllEditors = () => {
  //console.log("Registering all editors")
  registerEditor(NumericEditor)
  registerEditor(StringEditor)
  registerEditor(MarkdownEditor)
  registerEditor(TimelineEditor)
  registerEditor(PhotoEditor)
  registerEditor(SingleSelectEditor)
  registerEditor(MultiSelectEditor)
}
